// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* From Uiverse.io by PriyanshuGupta28 */
.InputWithLabel .input-container {
   position: relative;
   margin: 20px;
}

.InputWithLabel label {
   display: block;
   margin-bottom: 5px;
   color: #8a92a6 !important;
}

.InputWithLabel .input {
   padding: 8px 10px;
   font-size: 16px;
   border: 1px solid #8a92a6 !important;
   border-radius: 4px;
   background-color: #fff;
   color: #333;
   margin: auto;
   border: 1px solid #dadada;
   width: 100%;
   outline: none;
}

.InputWithLabel .input::placeholder {
   color: #b8c0d2;
}

.InputWithLabel .input:disabled {
   background-color: #eeeeee;
}

.InputWithLabel .input[type="text"]:placeholder-shown + label {
   position: absolute;
   top: 50%;
   left: 10px;
   transform: translateY(-50%);
   font-size: 14px;
   color: #777;
   pointer-events: none;
   transition: transform 0.3s, font-size 0.3s, color 0.3s;
}

.InputWithLabel .input[type="text"]:focus:not(:placeholder-shown) + label {
   transform: translateY(-25px);
   font-size: 12px;
   background-color: #4158d0;
   background-image: linear-gradient(
      43deg,
      #4158d0 0%,
      #c850c0 46%,
      #ffcc70 100%
   );
   animation: floating-label 0.3s forwards;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

/* From Uiverse.io by PriyanshuGupta28 */
.DropdownInput .input-container {
   position: relative;
   margin: 20px;
}

.DropdownInput label {
   display: block;
   margin-bottom: 5px;
   color: #8a92a6;
}

.DropdownInput .input {
   padding: 8px 10px;
   font-size: 16px;
   border: none;
   border-radius: 4px;
   background-color: #fff;
   color: #333;
   margin: auto;
   border: 1px solid #dadada;
   width: 100%;
   outline: none;
}

.DropdownInput .input[type="text"]:placeholder-shown + label {
   position: absolute;
   top: 50%;
   left: 10px;
   transform: translateY(-50%);
   font-size: 14px;
   color: #777;
   pointer-events: none;
   transition: transform 0.3s, font-size 0.3s, color 0.3s;
}

.DropdownInput .input[type="text"]:focus:not(:placeholder-shown) + label {
   transform: translateY(-25px);
   font-size: 12px;
   background-color: #4158d0;
   background-image: linear-gradient(
      43deg,
      #4158d0 0%,
      #c850c0 46%,
      #ffcc70 100%
   );
   animation: floating-label 0.3s forwards;
}
`, "",{"version":3,"sources":["webpack://./src/commanComponents/inputs/InputWithLabel.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC;GACG,kBAAkB;GAClB,YAAY;AACf;;AAEA;GACG,cAAc;GACd,kBAAkB;GAClB,yBAAyB;AAC5B;;AAEA;GACG,iBAAiB;GACjB,eAAe;GACf,oCAAoC;GACpC,kBAAkB;GAClB,sBAAsB;GACtB,WAAW;GACX,YAAY;GACZ,yBAAyB;GACzB,WAAW;GACX,aAAa;AAChB;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,yBAAyB;AAC5B;;AAEA;GACG,kBAAkB;GAClB,QAAQ;GACR,UAAU;GACV,2BAA2B;GAC3B,eAAe;GACf,WAAW;GACX,oBAAoB;GACpB,sDAAsD;AACzD;;AAEA;GACG,4BAA4B;GAC5B,eAAe;GACf,yBAAyB;GACzB;;;;;IAKC;GACD,uCAAuC;AAC1C;;AAEA,gCAAgC;AAChC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA,wCAAwC;AACxC;GACG,kBAAkB;GAClB,YAAY;AACf;;AAEA;GACG,cAAc;GACd,kBAAkB;GAClB,cAAc;AACjB;;AAEA;GACG,iBAAiB;GACjB,eAAe;GACf,YAAY;GACZ,kBAAkB;GAClB,sBAAsB;GACtB,WAAW;GACX,YAAY;GACZ,yBAAyB;GACzB,WAAW;GACX,aAAa;AAChB;;AAEA;GACG,kBAAkB;GAClB,QAAQ;GACR,UAAU;GACV,2BAA2B;GAC3B,eAAe;GACf,WAAW;GACX,oBAAoB;GACpB,sDAAsD;AACzD;;AAEA;GACG,4BAA4B;GAC5B,eAAe;GACf,yBAAyB;GACzB;;;;;IAKC;GACD,uCAAuC;AAC1C","sourcesContent":["/* From Uiverse.io by PriyanshuGupta28 */\n.InputWithLabel .input-container {\n   position: relative;\n   margin: 20px;\n}\n\n.InputWithLabel label {\n   display: block;\n   margin-bottom: 5px;\n   color: #8a92a6 !important;\n}\n\n.InputWithLabel .input {\n   padding: 8px 10px;\n   font-size: 16px;\n   border: 1px solid #8a92a6 !important;\n   border-radius: 4px;\n   background-color: #fff;\n   color: #333;\n   margin: auto;\n   border: 1px solid #dadada;\n   width: 100%;\n   outline: none;\n}\n\n.InputWithLabel .input::placeholder {\n   color: #b8c0d2;\n}\n\n.InputWithLabel .input:disabled {\n   background-color: #eeeeee;\n}\n\n.InputWithLabel .input[type=\"text\"]:placeholder-shown + label {\n   position: absolute;\n   top: 50%;\n   left: 10px;\n   transform: translateY(-50%);\n   font-size: 14px;\n   color: #777;\n   pointer-events: none;\n   transition: transform 0.3s, font-size 0.3s, color 0.3s;\n}\n\n.InputWithLabel .input[type=\"text\"]:focus:not(:placeholder-shown) + label {\n   transform: translateY(-25px);\n   font-size: 12px;\n   background-color: #4158d0;\n   background-image: linear-gradient(\n      43deg,\n      #4158d0 0%,\n      #c850c0 46%,\n      #ffcc70 100%\n   );\n   animation: floating-label 0.3s forwards;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n/* From Uiverse.io by PriyanshuGupta28 */\n.DropdownInput .input-container {\n   position: relative;\n   margin: 20px;\n}\n\n.DropdownInput label {\n   display: block;\n   margin-bottom: 5px;\n   color: #8a92a6;\n}\n\n.DropdownInput .input {\n   padding: 8px 10px;\n   font-size: 16px;\n   border: none;\n   border-radius: 4px;\n   background-color: #fff;\n   color: #333;\n   margin: auto;\n   border: 1px solid #dadada;\n   width: 100%;\n   outline: none;\n}\n\n.DropdownInput .input[type=\"text\"]:placeholder-shown + label {\n   position: absolute;\n   top: 50%;\n   left: 10px;\n   transform: translateY(-50%);\n   font-size: 14px;\n   color: #777;\n   pointer-events: none;\n   transition: transform 0.3s, font-size 0.3s, color 0.3s;\n}\n\n.DropdownInput .input[type=\"text\"]:focus:not(:placeholder-shown) + label {\n   transform: translateY(-25px);\n   font-size: 12px;\n   background-color: #4158d0;\n   background-image: linear-gradient(\n      43deg,\n      #4158d0 0%,\n      #c850c0 46%,\n      #ffcc70 100%\n   );\n   animation: floating-label 0.3s forwards;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
